import { getActionName } from '@kistler/skybase-ui/skybase-core/utils/get-action-name'
import { createAction } from '@kistler/skybase-ui/skybase-core/base/create-action'

export const SET_USER_TRACKING_STATUS = getActionName('SET_USER_TRACKING_STATUS')
export const setUserTrackingStatus = trackingState => createAction(SET_USER_TRACKING_STATUS, { trackingState })

export const SET_USER_TRACKING_DIALOG_OPEN = getActionName('SET_USER_TRACKING_DIALOG_OPEN')
export const setUserTrackingDialogOpen = shouldOpen => createAction(SET_USER_TRACKING_DIALOG_OPEN, { shouldOpen })
